import { TbSettings } from "react-icons/tb";
import { Action, ActionProps } from "../action";
import { forwardRef } from "react";

export const Settings = forwardRef<HTMLButtonElement, ActionProps>(
  (props: ActionProps, ref) => {
    return <Action {...props} ref={ref} Icon={TbSettings} variant="default" />;
  }
);
